import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  max-width: 320px;
  background-color: var(--primary);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  margin: 0 auto;

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

export const Image = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  transition: all 0.3s ease;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;  
  }

  &:hover {
      transform: scale(1.2);
  }
`;

export const Descricao = styled.div`
  padding: 16px;
  color: var(--white);

  @media (max-width: 480px) {
    padding: 12px;
  }

  h4 {
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  .local, .ref, .valor {
    display: block;
    margin-bottom: 8px;
  }

  .valor {
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--highlight);
  }

  a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--secondary);
    font-weight: 500;
    text-decoration: none;
  }
`;

export const Itens = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 0;
  color: var(--secondary);
  font-size: 0.85rem;

  span {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    flex: 1 1 45%;
  }
`;